/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){.contact-form-dialog{width:80vh}}@media screen and (min-width:600px){.contact-form-dialog{width:80vh}}@media screen and (min-width:1280px){.contact-form-dialog{width:600px}}.contact-form-dialog .mat-dialog-container{padding:0}.contact-form-dialog .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial}.contact-form-dialog .mat-dialog-container .toolbar-bottom{height:auto}.contact-form-dialog .mat-dialog-content{max-height:85vh;margin:0;padding:0}.contact-form-dialog .h-70-vh{height:70vh}"];
export { styles as styles };
